<template>
  <div class='home'>
    <CityList
      v-show='listView'
      @newCity='onClickNewFromList'
      @editCity='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <CityForm
      v-show='formView'
      :city='city'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import CityList from '@/components/city/CityList.vue'
import CityForm from '@/components/city/CityForm.vue'

export default {
  name: 'City',
  components: {
    CityList,
    CityForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      city: {
        id: null,
        name: null,
        area_id: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.city = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.city = {
        id: null,
        name: null,
        area_id: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.city = {
        id: null,
        name: null,
        area_id: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getAreaList')
  }
}
</script>
